import { atom } from "jotai";

export const isExecutingZslAtom = atom(false);
isExecutingZslAtom.debugLabel = "isExecutingZslAtom";
